import React, {Component} from "react";
import Objects from "../../redux/Objects";
import {connect} from "react-redux";

class Toast extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={"toast-tutorfest" + (this.props.toast ? " active" : "")}>
                <span>
                    {this.props.toastMsg}
                </span>
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        toast: state.param[Objects.toast],
        toastMsg: state.param[Objects.toastMsg],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Toast)
